/**
 * Breadcrumb
 */

// Custom
import 'protons';

// Module template
import './_breadcrumb.twig';

// Module styles
import './_breadcrumb.scss';

export const name = 'breadcrumb';

export function disable() {}

export function enable() {}

export default enable;
